/** 运行配置：运行时类型 / workload / 部署模式（逻辑 key） */
export const RUNTIME_CONFIG_FIELD_KEYS = {
  runtimeType: 'mi.runtime.type',
  runtimeWorkload: 'mi.runtime.workload',
  /** 模型实例 PD 部署方式（表单字段 `_inferencePdSeparation`） */
  deployMode: 'mi.deployMode',
} as const;

export const RUNTIME_CONFIG_FIELD_KEY_LIST = [
  RUNTIME_CONFIG_FIELD_KEYS.runtimeType,
  RUNTIME_CONFIG_FIELD_KEYS.runtimeWorkload,
  RUNTIME_CONFIG_FIELD_KEYS.deployMode,
] as const;
